import { PropsWithChildren, createContext, useContext, useState } from 'react';

type TitleContextModel = string | undefined;
type SetTitleContextModel = (payload: TitleContextModel) => void;

const PageTitleContext = createContext<TitleContextModel>(undefined);

const SetPageTitleContext = createContext<SetTitleContextModel>(() => {});

export function PageTitleContextProvider(
  props: Readonly<PropsWithChildren>,
): React.JSX.Element {
  const { children } = props;

  const [title, setTitle] = useState<TitleContextModel>();

  return (
    <PageTitleContext.Provider value={title}>
      <SetPageTitleContext.Provider value={setTitle}>
        {children}
      </SetPageTitleContext.Provider>
    </PageTitleContext.Provider>
  );
}

export function usePageTitleContext(): TitleContextModel {
  return useContext(PageTitleContext);
}

export function useSetPageTitleContext(): SetTitleContextModel {
  return useContext(SetPageTitleContext);
}
